<template>
  <div>
    <v-flex md12>
      <v-row>
        <v-col cols="8" class="pa-1">
          <span class="pl-2 pt-2 pr-3 mb-2 headline">
            {{ order.number || '' }} {{ order.number ? '-' : '' }}
            <router-link :to="`/customers/edit/${order.customerid}/view`" target="_blank">{{ order.ordercustomerdata.Name || '' }}</router-link>
          </span>
          <span class="text-right title">
            ({{ getStatusName(order.state) }})
          </span>
        </v-col>
        <v-col cols="4" class="pa-1 text-right" v-if="order.type === 'sales'">
          <span class="pr-5">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark v-bind="attrs" v-on="on">
                  {{ $t('message.common.new') }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in types" :key="index" :to="`/orders/actions?type=${item.value}&salesid=${orderId}`">
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </span>
        </v-col>
        <v-col cols="4" class="pa-1 text-right" v-if="order.order_id">
          <span class="title">{{ $t('message.orders.restOrderFor') }}
            <router-link :to="`/orders/edit/${order.order_id}/view`">{{ order.order_number }}</router-link>
          </span>
        </v-col>
      </v-row>
      <div class="clearfix"></div><div class="clearfix"></div>
      <v-tabs background-color="primary" grow dark>
        <v-tab :to="`/orders/edit/${orderId}/view`"><v-icon color="white">mdi-format-float-left</v-icon> &nbsp; {{ getModuleName() }}</v-tab>
        <v-tab :to="`/orders/edit/${orderId}/documents`"><v-icon color="white">mdi-file-multiple</v-icon> &nbsp;{{ $t('message.order.documents') }}</v-tab>
        <v-tab :to="`/orders/edit/${orderId}/materials`" v-if="order.type !== 'sales'"><v-icon color="white">mdi-chart-line-variant</v-icon> &nbsp;{{ $t('message.order.orderBillingData') }}</v-tab>
        <v-tab :to="`/orders/edit/${orderId}/deviations`" v-if="order.type !== 'sales'"><v-icon color="white">mdi-chart-line-stacked</v-icon> &nbsp;{{ $t('message.layout.deviations') }}</v-tab>
        <v-tab :to="`/orders/edit/${orderId}/checklist`" v-if="order.type !== 'sales'"><v-icon color="white">mdi-equal-box</v-icon> &nbsp;{{ $t('message.layout.checklists') }}</v-tab>
        <v-tab v-if="order.type !== 'offer' && order.type !== 'sales'" :to="`/orders/edit/${orderId}/invoice`"><v-icon color="white">mdi-currency-eur</v-icon> &nbsp;{{ $t('message.customer.invoice') }}</v-tab>
        <v-tab :to="`/orders/edit/${orderId}/certificate`" v-if="order.type !== 'sales'"><v-icon color="white">mdi-certificate</v-icon> &nbsp;{{ $t('message.order.certificate') }}</v-tab>
      </v-tabs>
    </v-flex>
    <v-progress-linear class="mt-2" indeterminate v-if="listPayloadObj.loading"></v-progress-linear>
    <router-view></router-view>
    <v-dialog v-model="shareDialog" persistent max-width="1150px" class="mt-0">
      <v-form ref="shareForm" onSubmit="return false;">
        <v-card>
          <v-card-title>
            <template v-if="order.type === 'order'">
              {{ sendDialogHeading ? `${$t('message.common.send')} ${sendDialogHeading.toLowerCase()}` : `${$t('message.order.sendOrder')}` }}
            </template>
            <template v-else-if="order.type === 'offer'">
              {{ sendDialogHeading ? `${$t('message.common.send')} ${sendDialogHeading.toLowerCase()}` : `${$t('message.order.sendOffer')}` }}
            </template>
            <template v-else-if="order.type === 'sales'">
              {{ $t('message.order.sendSales') }}
            </template>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-2">
            <v-col cols="12">
              <v-row>
                <v-autocomplete outlined dense name="contact" hide-details v-model="activeContact" @change="getEmailForContact"
                  :items="contactsList" item-text="name" item-value="id" :loading="loadingContacts"
                  :label="$t('message.orders.contact')">
                </v-autocomplete>
              </v-row>
              <v-row class="mt-4">
                <v-text-field outlined dense v-model="mails" ref="autoFocus" :rules="$_requiredValidation"
                  persistent-hint :hint="$t('message.common.add_extra_mails')"></v-text-field>
              </v-row>
              <v-row class="mt-4">
                <v-text-field outlined dense v-model="mail.subject" :rules="$_requiredValidation"
                  persistent-hint :hint="$t('message.tickets.subject')"></v-text-field>
              </v-row>
              <v-row>
                <!-- <v-textarea outlined textarea :label="$t('message.tickets.body')" v-model="mail.body" hide-details></v-textarea> -->
                <v-flex xs12>
                  <label class="subtitle-1">{{ $t('message.tickets.body') }}</label>
                  <ckeditor :editor="editor" v-model="mail.body" :config="configEditor"></ckeditor>
                </v-flex>
              </v-row>
              <v-row>
                <v-checkbox dense :label="$t('message.common.copy_to_me')" v-model="isCopyToMe" hide-details color="primary"></v-checkbox>
              </v-row>
              <v-row v-if="order && order.type !== 'sales'">
                <attach_share v-model="filelist" v-if="shareDialog" :filelist="filelist" :sharepoint="sharepointObj"></attach_share>
              </v-row>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" id="sendMail" :loading="shareLoading" @click="shareReport">{{ $t('message.common.send') }}</v-btn>
            <v-btn color="error" id="close" @click="closeShareDialog">{{ $t('message.common.close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
/* eslint-disable camelcase */
import axios from 'axios'
import orderReport from '@/mixins/Order/report'
import packReport from '@/mixins/Order/packing_list'
import nvitPackReport from '@/mixins/Order/nvit_packing_list'
import pickReport from '@/mixins/Order/pick_list'
import purchaseReport from '@/mixins/Order/purchase_list'
import { getOrderTemplate, getOfferTemplate } from '@/constants'
import Editor from '@/ckeditor'
export default {
  data () {
    return {
      orderId: this.$route.params.order_id,
      order: {
        ordercustomerdata: {},
        ordercustomercontactdata: {}
      },
      listPayloadObj: {
        loading: false
      },
      shareDialog: false,
      shareLoading: false,
      mails: '',
      isValidEmail: false,
      isCopyToMe: false,
      canDeleteOrder: false,
      typeOfShare: 1,
      companyName: '',
      commercialInvoiceId: null,
      loadingContacts: false,
      contactsList: [],
      filelist: [],
      activeContact: 0,
      mail: { // for task #11760
        subject: '',
        body: ''
      },
      editor: Editor,
      configEditor: {
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            '|',
            'bulletedList',
            'numberedList',
            '|',
            'undo',
            'redo'
          ]
        }
      },
      sharepointObj: {
        loading: false,
        files: []
      },
      sharepointId: '',
      sendDialogHeading: '',
      settingsObj: {}
    }
  },
  created () {
    this.getSettings()
    this.getInvoiceSettings()
  },
  mounted () {
    this.getOrderData()
    this.getOrderDetailedView()
  },
  components: {
    'attach_share': () => import('@/components/AttachFileToMail.vue')
  },
  computed: {
    offerReportOptions () {
      return [{
        text: this.$t('message.common.offerConfirm'),
        value: 1
      }, {
        text: this.$t('message.common.offerWithZone'),
        value: 7
      }]
    },
    orderReportOptions () {
      return [{
        text: this.$t('message.common.orderConfirm'),
        value: 1
      }, {
        text: this.$t('message.common.orderConfirmWithData'),
        value: 2
      }, {
        text: this.$t('message.order.confirmationWithZone'),
        value: 7
      }, {
        text: this.$t('message.orders.packList'),
        value: 3
      }, {
        text: this.$t('message.orders.pickList'),
        value: 5
      }, {
        text: this.$t('message.order.purchaseList'),
        value: 6
      }, {
        text: this.$t('message.common.commercialInvoice'),
        value: 4
      }, {
        text: this.$t('message.orders.nvitPackList'),
        value: 8
      }]
    },
    types () {
      return [{
        name: this.$t('message.layout.offer'),
        value: 'offer'
      }, {
        name: this.$t('message.layout.order'),
        value: 'order'
      }]
    }
  },
  mixins: [orderReport, packReport, nvitPackReport, pickReport, purchaseReport],
  methods: {
    getModuleName () {
      if (this.order.type === 'offer') return this.$t('message.layout.offer')
      else if (this.order.type === 'sales') return this.$t('message.layout.sales')
      else return this.$t('message.orders.orderDetails')
    },
    getOrderData () {
      const model = {
        expand: [
        //   {
        //   select: ['name', 'email', 'vatid', 'paymentmethod2'],
        //   model: 'Customer',
        //   on_field: 'Id',
        //   on_parent_field: 'customerid'
        // }, {
        //   select: ['firstname', 'lastname', 'email'],
        //   model: 'Contact',
        //   on_field: 'id',
        //   on_parent_field: 'contactid'
        // },
          {
            select: ['id', 'number'],
            model: 'Order',
            on_field: 'id',
            on_parent_field: 'restcreatedfrom'
          }, {
            select: ['number', 'type', 'sharepoint_id'],
            model: 'Order',
            on_field: 'id',
            on_parent_field: 'source_ref'
          }],
        filter: `id eq ${this.orderId}`
      }
      this.$_executeApi('post', 'orders/query', model).then((response) => {
        this.order = response.data && response.data[0] ? response.data[0] : {}
        this.order.ordercustomerdata = this.order.ordercustomerdata ? JSON.parse(this.order.ordercustomerdata) : {}
        this.order.ordercustomercontactdata = this.order.ordercustomercontactdata ? JSON.parse(this.order.ordercustomercontactdata) : {}
        this.order.contactname = `${this.order.ordercustomercontactdata.FirstName || ''} ${this.order.ordercustomercontactdata.LastName || ''}`
        document.title = `Tilbud/Ordre - ${this.order.number || ''}`
      })
    },
    getOrderDetailedView () {
      return new Promise((resolve, reject) => {
        this.$_executeApi('get', `orders/get_detail_view/${this.orderId}`)
          .then((result) => {
            let transformData = { date: { list: ['orderdate', 'offerdate', 'deliverydate'], from: 'DD.MM.YYYY', to: 'DD.MM.YYYY' },
              number: { list: ['totalsum', 'totalexvat', 'totalvat', 'dg'], format: 'replaceDotWithComma' } }
            let model = this.$_formatModel(result.data, transformData)
            this.canDeleteOrder = model.candelete
            const alreadyAddedId = []
            const relatedOrders = []
            model.source_ref_number = model.source_ref_number ? JSON.parse(model.source_ref_number) : []
            model.source_ref_number_1 = model.source_ref_number_1 ? JSON.parse(model.source_ref_number_1) : []
            const mergedData = [...model.source_ref_number, ...model.source_ref_number_1]
            mergedData.map(y => {
              if (!alreadyAddedId.includes(y.Id)) {
                relatedOrders.push(y)
                alreadyAddedId.push(y.Id)
              }
            })

            this.$eventBus.$emit('showRelatedItems', relatedOrders)
            this.listPayloadObj.list = [model]
            resolve(model)
          })
          .catch((ex) => {
            reject(ex)
          })
      })
    },
    async downloadOrder (type, commercialInvoiceId = null) {
      this.listPayloadObj.loading = true
      this.$eventBus.$emit('downloadLoading', true)
      var visibleName = `${this.getTypeName()}_${this.order.number}`
      if (this.order.type === 'offer') {
        visibleName = `${this.$t('message.layout.offer')}_${this.order.number}`
      }
      this.getOrderDetailedView().then(async (reportData) => {
        this.$_executeApi('post', `orders/generate_pdf/${+this.orderId}/${type}/download`, { visiblefilename: visibleName, content: await this.genereateReportContent(reportData, type, commercialInvoiceId) })
          .then((response) => {
            let fileName = response.data
            window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
          })
          .finally(() => {
            this.listPayloadObj.loading = false
            this.$eventBus.$emit('downloadLoading', false)
          })
      })
    },
    async downloadOrderWithZone (type, commercialInvoiceId = null) {
      this.listPayloadObj.loading = true
      this.$eventBus.$emit('downloadLoading', true)
      var visibleName = `Ordrebekreftelse_${this.order.number}_${this.$_getCurrentDate()}`
      if (this.order.type === 'offer') {
        visibleName = `${this.$t('message.layout.offer')}_${this.order.number}_${this.$t('message.orders.perzone')}`
      }
      this.getOrderDetailedView().then(async (reportData) => {
        this.$_executeApi('post', `orders/generate_pdf/${+this.orderId}/${type}/download`, { visiblefilename: visibleName, content: await this.genereateReportContent(reportData, type, commercialInvoiceId) })
          .then((response) => {
            let fileName = response.data
            window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
          })
          .finally(() => {
            this.listPayloadObj.loading = false
            this.$eventBus.$emit('downloadLoading', false)
          })
      })
    },
    async downloadPackListOrder () {
      this.listPayloadObj.loading = true
      this.$eventBus.$emit('downloadLoading', true)
      this.getOrderDetailedView().then(async (reportData) => {
        this.$_executeApi('post', `orders/generate_packing_report/${this.order.id}/packlist/download`, { visiblefilename: `Pakkseddel_${this.order.number}`, content: await this.genereatePackReportContent(reportData) })
          .then((response) => {
            let fileName = response.data
            window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
          })
          .finally(() => {
            this.$eventBus.$emit('downloadLoading', false)
            this.listPayloadObj.loading = false
          })
      })
    },
    async downloadNvitPackListOrder () {
      this.listPayloadObj.loading = true
      this.$eventBus.$emit('downloadLoading', true)
      this.getOrderDetailedView().then(async (reportData) => {
        this.$_executeApi('post', `orders/generate_packing_report/${this.order.id}/packlist/download`, { islandscape: true, visiblefilename: `NVIT_pakkseddel_${this.order.number}`, content: await this.genereateNvitPackReportContent(reportData) })
          .then((response) => {
            let fileName = response.data
            window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
          })
          .finally(() => {
            this.$eventBus.$emit('downloadLoading', false)
            this.listPayloadObj.loading = false
          })
      })
    },
    async downloadPurchaseListOrder () {
      this.listPayloadObj.loading = true
      this.$eventBus.$emit('downloadLoading', true)
      this.getOrderDetailedView().then(async (reportData) => {
        this.$_executeApi('post', `orders/generate_packing_report/${this.order.id}/purchaselist/download`, { visiblefilename: `Ordreplan_${this.order.number}`, content: await this.genereatePurchaseReportContent(reportData) })
          .then((response) => {
            let fileName = response.data
            window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
          })
          .finally(() => {
            this.listPayloadObj.loading = false
            this.$eventBus.$emit('downloadLoading', false)
          })
      })
    },

    async downloadPickListOrder () {
      this.listPayloadObj.loading = true
      this.$eventBus.$emit('downloadLoading', true)
      this.getOrderDetailedView().then(async (reportData) => {
        this.$_executeApi('post', `orders/generate_packing_report/${this.order.id}/picklist/download`, { islandscape: true, visiblefilename: `Plukkseddel_${this.order.number}`, content: await this.genereatePickReportContent(reportData) })
          .then((response) => {
            let fileName = response.data
            window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
          })
          .finally(() => {
            this.$eventBus.$emit('downloadLoading', false)
            this.$eventBus.$emit('downloadComplete', true)
            this.listPayloadObj.loading = false
          })
      })
    },
    async sendReport (type, commercialInvoiceId = null) {
      this.activeContact = this.order.contactid
      this.getContacts(this.order)
      this.shareDialog = true
      this.mails = this.order.ordercustomercontactdata ? this.order.ordercustomercontactdata.Email || '' : ''
      this.typeOfShare = type
      this.commercialInvoiceId = commercialInvoiceId
      // get sharepoint docs to be shared
      this.sharepointId = this.order.sharepoint_id
      this.sharepointObj.files = []
      this.filelist = []
      if (this.sharepointId) this.getAllDocumentsFromSharepoint(this.sharepointId)
      /* Set template data */
      const { mail_signature } = this.$formatter.cloneVariable(this.settingsObj)
      if (this.order.type === 'offer') {
        const offerEmailTemplate = getOfferTemplate(this.order)
        this.mail.subject = offerEmailTemplate.subject
        this.mail.body = `${offerEmailTemplate.body} ${mail_signature}`
        const getTypeName = this.offerReportOptions.find(x => x.value === type)
        this.sendDialogHeading = getTypeName.text || ''
      } else {
        const getTypeName = this.orderReportOptions.find(x => x.value === type)
        this.sendDialogHeading = getTypeName.text || ''
        const orderEmailTemplate = getOrderTemplate(getTypeName.text || '', this.order)
        this.mail.subject = orderEmailTemplate.subject
        this.mail.body = `${orderEmailTemplate.body} ${mail_signature}`
      }
    },
    async shareReport () {
      if (this.$refs.shareForm.validate()) {
        this.shareLoading = true
        if (!this.mails.length > 0) this.isValidEmail = true
        let getMailIDsString = this.mails
        let listOfMailIds = getMailIDsString.split(',')
        if (listOfMailIds && listOfMailIds.length > 0) {
          for (let i = 0; i < listOfMailIds.length; i++) {
            if (listOfMailIds[i]) {
              listOfMailIds[i] = listOfMailIds[i].trim()
              this.validEmail(listOfMailIds[i]) ? this.isValidEmail = false : this.isValidEmail = true
            }
          }
        }
        if (!this.isValidEmail) {
          let currentUserMail = this.$store.state.userDetails ? this.$store.state.userDetails.email : ''
          this.shareLoading = true
          this.getOrderDetailedView().then(async (reportData) => {
            let model = {}
            let url = ''
            if (this.typeOfShare === 3) {
              model = { visiblefilename: `Pakkseddel_${this.order.number}`, content: await this.genereatePackReportContent(reportData) }
              url = `orders/generate_packing_report/${this.order.id}/packlist/share`
            } else if (this.typeOfShare === 8) {
              model = { islandscape: true, visiblefilename: `NVIT_pakkseddel_${this.order.number}`, content: await this.genereateNvitPackReportContent(reportData) }
              url = `orders/generate_packing_report/${this.order.id}/packlist/share`
            } else if (this.typeOfShare === 5) {
              model = { islandscape: true, visiblefilename: `Plukkseddel_${this.order.number}`, content: await this.genereatePickReportContent(reportData) }
              url = `orders/generate_packing_report/${this.order.id}/picklist/share`
              this.$eventBus.$emit('downloadComplete', true)
            } else if (this.typeOfShare === 6) {
              model = { islandscape: true, visiblefilename: `Ordreplan_${this.order.number}`, content: await this.genereatePurchaseReportContent(reportData) }
              url = `orders/generate_packing_report/${this.order.id}/purchaselist/share`
              this.$eventBus.$emit('downloadComplete', true)
            } else if (this.typeOfShare === 7) {
              model = { visiblefilename: `Ordrebekreftelse_${this.order.number}_${this.$_getCurrentDate()}`, content: await this.genereateReportContent(reportData, this.typeOfShare, this.commercialInvoiceId) }
              url = `orders/generate_pdf/${this.order.id}/${this.typeOfShare}/share`
            } else {
              model = { visiblefilename: `${this.getTypeName()}_${this.order.number}`, content: await this.genereateReportContent(reportData, this.typeOfShare, this.commercialInvoiceId) }
              url = `orders/generate_pdf/${this.order.id}/${this.typeOfShare}/share`
            }
            if (this.order.type === 'offer') {
              if (this.typeOfShare === 1) {
                model.visiblefilename = `${this.$t('message.common.offerConfirm')}_${this.order.number}`
              } else if (this.typeOfShare === 7) {
                model.visiblefilename = `Tilbudbekreftelse_${this.order.number}__${this.$_getCurrentDate()}`
              }
            }
            this.$_executeApi('post', url, model)
              .then(async (response) => {
                let fileName = response.data
                let model = { to: listOfMailIds, cc: this.isCopyToMe && currentUserMail ? [currentUserMail] : [], subject: this.mail.subject, body: this.mail.body, filename: fileName }

                // if type is OFFER/ORDERFER
                if (this.order && this.order.type !== 'sales') {
                  // upload files to local for share attachments
                  const formData = new FormData()
                  const files = this.filelist
                  files.forEach(file => {
                    if (!file.is_sharepoint) {
                      formData.append(file.name, file)
                    } else {
                      formData.append(file.id, file)
                    }
                  })
                  await this.$_executeApi('post', `warehouseorders/attachment_upload/${this.order.id}/ORDER_OFFER`, formData)
                }

                this.$_executeApi('post', `orders/share/${this.order.id}`, model)
                  .then((response) => {
                    this.closeShareDialog()
                    this.shareLoading = false
                    this.getOrderData()
                    this.$eventBus.$emit('loadOffer')
                    this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.tickets.sentSuccess') })
                  })
              })
              .catch((err) => {
                this.shareLoading = false
                console.log(err)
              })
          })
        } else {
          this.shareLoading = false
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.invalidEmail') })
        }
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
      }
    },
    getStatusName (status) {
      let statusList = this.$formatter.cloneVariable(this.$_orderOfferStatus)
      let getStatus = statusList.find(x => x.id === status)
      if (getStatus) return getStatus.name
      else return ''
    },
    getSettings () {
      this.$_executeApi('get', 'commonsettings').then(response => {
        let { partyname } = response.data
        this.companyName = partyname
      })
    },
    getEmailForContact () {
      let getContact = this.contactsList.find(x => x.id === this.activeContact)
      if (getContact) {
        this.mails = getContact.email
      }
    },
    getContacts (item) {
      this.contactsList = []
      this.loadingContacts = true
      let query = { filter: `customer_id eq ${item.customerid}` }
      this.$_executeApi('post', `contacts/query`, query)
        .then(response => {
          let list = response.data
          list.map(x => {
            x.name = `${x.firstname || ''} ${x.lastname || ''}`
            return x
          })
          this.contactsList = list
        })
        .finally(() => {
          this.loadingContacts = false
        })
    },
    validEmail: function (email) {
      // eslint-disable-next-line no-useless-escape
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    getTypeName () {
      if (this.order.type === 'offer') return this.$t('message.layout.offer')
      else if (this.order.type === 'sales') return this.$t('message.layout.sales')
      else if (this.order.type === 'order') return this.$t('message.layout.order')
      else if (this.order.type === 'rest_order') return 'Rest_Order'
    },
    closeShareDialog () {
      this.mails = ''
      this.shareDialog = false
    },
    getInvoiceSettings () {
      this.$_getSingleRecordHandler('invoicesettings')
        .then((result) => {
          if (result.data) this.settingsObj = result.data
        })
    },
    getAllDocumentsFromSharepoint (id) {
      this.sharepointObj.loading = true
      let childSPId = []
      if (this.order.order_type === 'offer' && this.order.order_sharepoint_id) {
        childSPId = [this.order.order_sharepoint_id || 0]
      }
      this.$_executeApi('post', `sharepoint/get_multiple_sp_docs/${id}`, childSPId)
        .then((response) => {
          if (response) {
            let { childrenfolderitems, parentfolderitems } = response.data
            childrenfolderitems = childrenfolderitems.filter(x => x.is_document)
            parentfolderitems = parentfolderitems.filter(x => x.is_document)
            this.sharepointObj.files = [...parentfolderitems, ...childrenfolderitems]
          }
        })
        .finally(() => {
          this.sharepointObj.loading = false
        })
    }
  }
}
</script>
